import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import Confetti, { ConfettiHandle } from "@/components/Confetti/Confetti";
import { StarIcon } from "@/assets/icons";
import { useWelcomeInfo } from "@/store/welcomeInfo";
import Modal from "@/ui/Modal/Modal";
import Button from "@/ui/Button/Button";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { useConfettiShow } from "@/utils/hooks/useConfettiShow";
import { useRampHaptic } from "@/utils/hooks/useRampHaptic";
import cls from "./styles.module.scss";

function getDayLabel(days: number) {
  const mod10 = days % 10;
  const mod100 = days % 100;

  if (mod10 === 1 && mod100 !== 11) return "день";
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return "дня";
  return "дней";
}

const PromoGiftContent = ({
  days,
  onClose,
}: {
  days: number;
  onClose: () => void;
}) => {
  const confettiRef = useRef<ConfettiHandle>(null);
  const { ramp } = useRampHaptic();
  const { fireworkParty, fireFromCorners } = useConfettiShow(confettiRef);

  useEffect(() => {
    const cornersTimer = window.setTimeout(() => {
      fireFromCorners();
      ramp(25, 15);
    }, 750);

    const fireworksTimer = window.setTimeout(() => {
      fireworkParty(8, 250);
    }, 1350);

    return () => {
      window.clearTimeout(cornersTimer);
      window.clearTimeout(fireworksTimer);
    };
  }, [fireFromCorners, fireworkParty, ramp]);

  return (
    <>
      <Confetti ref={confettiRef} />
      <FlexColumn gap={16} alignItems="center" className={cls.text}>
        <div className={cls.present}>
          <StarIcon className={cn(cls.star, cls.starOne)} size={25} />
          <StarIcon className={cn(cls.star, cls.starTwo)} size={43} />
          <StarIcon className={cn(cls.star, cls.starThree)} size={33} />
          <img src="/assets/present.png" alt="present" />
        </div>
        <Typography variant="h3">
          {`Тебе подарок - ${days} ${getDayLabel(days)} КЭФА 🎉`}
        </Typography>
        <Typography style={{ whiteSpace: "pre-line" }}>
          Успей выполнить 20 заказов за этот период{"\n"}и получи месяц Большого
          Кэфа бесплатно!
        </Typography>
        <Button
          className={cls.thanksBtnPlusThree}
          onClick={onClose}
          label="Спасибо 🎉"
        />
      </FlexColumn>
    </>
  );
};

export default function PromoGiftModal() {
  const { promoGiftDays, setPromoGiftDays } = useWelcomeInfo();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!promoGiftDays) return;
    setIsOpen(true);
  }, [promoGiftDays]);

  const onClose = () => {
    setIsOpen(false);
    setPromoGiftDays(null);
  };

  if (!promoGiftDays) return null;

  return (
    <Modal
      overlayCls={cls.overlay}
      wrapperCls={cls.modalPlusThree}
      isOpen={isOpen}
      onClose={onClose}
      hideCloseBtn
      ignoreTranslate
    >
      <PromoGiftContent days={promoGiftDays} onClose={onClose} />
    </Modal>
  );
}
